import MessagingDashboard from 'src/modules/concession/messaging/dasboard/MessagingDashboard.vue'

import { GlobalController } from 'src/shared/global/GlobalController'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'dashboard',
    name: 'MessagingDashboard',
    component: MessagingDashboard,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
